import { TRAINING_OFFERS } from './trainingOffers';
import { catalogue as frenchCatalogue, offers as frenchOffers } from './content/fr';
import { catalogue as englishCatalogue, offers as englishOffers } from './content/en';

const contentByLocale = Object.freeze({
  fr: Object.freeze({ catalogue: frenchCatalogue, offers: frenchOffers }),
  en: Object.freeze({ catalogue: englishCatalogue, offers: englishOffers }),
});

const offerKeys = new Set(TRAINING_OFFERS.map(({ key }) => key));

export const getTrainingContent = (locale, offerKey) => {
  if (!offerKeys.has(offerKey)) {
    return undefined;
  }

  return contentByLocale[locale]?.offers[offerKey];
};

export const getCatalogueContent = (locale) => contentByLocale[locale]?.catalogue;
